import { TranslationKeys } from 'localization';
import { WorkOrderModuleCategoriesSettings } from 'lane-shared/domains/workOrder';

export type DropdownOption = { label: string; value: string };

export const ALL_ISSUE_TYPES_VALUE = 'ALL_ISSUE_TYPES';
export const NONE_ISSUE_TYPE_VALUE = 'NONE';

export function getIssueTypeInfoKey(
  issueTypeValue: string
): TranslationKeys | null {
  if (issueTypeValue === ALL_ISSUE_TYPES_VALUE) {
    return 'web.admin.serviceRequest.settings.coverageHours.create.allIssueTypesInfo';
  }

  if (issueTypeValue === NONE_ISSUE_TYPE_VALUE) {
    return 'web.admin.serviceRequest.settings.coverageHours.create.noneIssueTypeInfo';
  }

  return null;
}

export function buildCategoryItems(
  categories: WorkOrderModuleCategoriesSettings[]
): DropdownOption[] {
  return categories
    .filter(c => (c.firendlyName ?? '').trim() !== '')
    .map(c => ({ label: c.firendlyName, value: c.firendlyName }));
}

export function findSelectedCategory(
  categories: WorkOrderModuleCategoriesSettings[],
  categoryValue: string | null
): WorkOrderModuleCategoriesSettings | undefined {
  return categories.find(c => c.firendlyName === categoryValue);
}

// An empty issues list means a single category-level routing with no issue —
// this is the exact contract InputCreateCoverageHours.issues documents.
export function resolveIssues(
  issueTypeValue: string,
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined
): string[] {
  if (issueTypeValue === NONE_ISSUE_TYPE_VALUE) {
    return [];
  }

  if (issueTypeValue === ALL_ISSUE_TYPES_VALUE) {
    return (selectedCategory?.issues ?? []).filter(
      i => (i ?? '').trim() !== ''
    );
  }

  return [issueTypeValue];
}

export function buildIssueTypeItems(
  selectedCategory: WorkOrderModuleCategoriesSettings | undefined,
  t: (key: string) => string
): DropdownOption[] {
  if (!selectedCategory) {
    return [];
  }

  const issues = (selectedCategory.issues ?? []).filter(
    i => (i ?? '').trim() !== ''
  );

  return [
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.create.allIssueTypes'
      ),
      value: ALL_ISSUE_TYPES_VALUE,
    },
    {
      label: t(
        'web.admin.serviceRequest.settings.coverageHours.create.none'
      ),
      value: NONE_ISSUE_TYPE_VALUE,
    },
    ...issues.map(issue => ({ label: issue, value: issue })),
  ];
}
